import React, { memo, useEffect } from 'react';
import { Grid, Theme } from '@material-ui/core';
import { withStyles, WithStyles, createStyles } from '@material-ui/core/styles';
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';
import { ActionModal } from '../../../components/Modal';
import { Typography } from '../../../components/Typography';

const styles = (theme: Theme) => {
  return createStyles({
    userCard: {},
    right: {
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'column',
    },
  });
};

export interface IDeleteUserModalProps extends WithStyles<typeof styles> {
  customStyles?: any;
  open: boolean;
  selectedUser: any;
  handleClose?: any;
  handleDeleteUser: (id: string) => void;
  selectUser: any;
}

const DeleteUserModal = ({
  classes,
  open,
  selectedUser,
  handleClose,
  handleDeleteUser,
  selectUser,
}: IDeleteUserModalProps) => {
  useEffect(() => {
    handleClose();
  }, [selectUser.loading]);

  return (
    <ActionModal
      modalTitle="Do you want to delete this user ?"
      open={open}
      handleClose={handleClose}
      actinButtonLabel="Delete"
      actinButtonOnClick={() => handleDeleteUser(selectedUser?._id)}
    >
      <Grid container className={classes.userCard}>
        <Grid item xs={1}>
          <PersonOutlineOutlinedIcon color="primary" fontSize="large" />
        </Grid>
        <Grid item className={classes.right}>
          <Typography variant="body1" color="primary">
            <b>{selectedUser?.profile?.name || 'Not available'}</b>
          </Typography>
          <Typography variant="body2" color="secondary">
            {selectedUser?.email || 'Not available'}
          </Typography>
        </Grid>
      </Grid>
    </ActionModal>
  );
};

export default memo(withStyles(styles)(DeleteUserModal));
